import { AuthorizeDirective } from './authorize.directive';

export const Directives: any[] = [AuthorizeDirective];

export * from './authorize.directive';
